import {
  Page
} from '../models';

const mapRelationships = (obj, included) => {
  return Object.keys(obj).flatMap((key) => {
    const item = obj[key];

    return item.data.flatMap((rel) => {
      return included.flatMap((meta) => {
        if (rel.id === meta.id) {
          return {
            type: meta.type,
            field: key,
            subPageContent: meta.attributes.field_page_content
          };
        }
        return [];
      });
    });
  });
};

export const mapPage = (result) => {

  return result.data
    .map((item) => {

      return {
        attributes: {
          ...item.attributes,
          relationships: mapRelationships(item.relationships, result.included),
          id: item.id
        }
      };
    })
    .map(item => {
      return new Page(item).mapToStandard();
    });
};
